(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bm-variant-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bm-variant-cards')) {
    customElements.define(
      'bm-variant-cards',
      class BmVariantCards extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.section;
          this.productInfo = this.closest('product-info');
          this.onCardChange = this.onCardChange.bind(this);
          this.onIdChange = this.onIdChange.bind(this);
          this.addEventListener('change', this.onCardChange);
          document.addEventListener('change', this.onIdChange);
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.onCardChange);
          document.removeEventListener('change', this.onIdChange);
        }

        get nativePicker() {
          // Looked up each time: product-info.js swaps variant-selects after every change
          return (
            (this.productInfo && this.productInfo.querySelector('variant-selects')) ||
            document.getElementById(`variant-selects-${this.sectionId}`)
          );
        }

        onCardChange(event) {
          const input = event.target;
          if (!input.matches('[data-bm-vc-input]')) return;
          // Native mode: the inner variant-selects has already handed this to product-info.js
          if (this.dataset.mode === 'native') return;
          event.stopPropagation();

          let options = [];
          try {
            options = JSON.parse(input.dataset.options || '[]');
          } catch (error) {
            options = [];
          }

          if (!this.selectNative(options)) this.fallback(input.value);
        }

        selectNative(options) {
          const picker = this.nativePicker;
          if (!picker || !options.length) return false;

          let changed = null;
          let resolved = 0;

          options.forEach((value, index) => {
            const wrapper = picker.querySelector(`[data-option-position="${index + 1}"]`);
            if (!wrapper) return;

            // Button and swatch pickers
            const radio = Array.from(wrapper.querySelectorAll('input[type="radio"]')).find(
              (el) => el.value === value
            );
            if (radio) {
              resolved += 1;
              if (!radio.checked) {
                radio.checked = true;
                changed = radio;
              }
              return;
            }

            // Dropdown picker
            const item = Array.from(wrapper.querySelectorAll('[data-popout-list] li')).find(
              (li) => li.getAttribute('value') === value
            );
            const hidden = wrapper.querySelector('[data-popout-input]');
            if (item && hidden) {
              resolved += 1;
              if (hidden.value !== value) {
                hidden.value = value;
                hidden.dataset.optionValueId = item.dataset.optionValueId;
                hidden.dataset.productUrl = item.dataset.productUrl;
                changed = hidden;
              }
            }
          });

          if (resolved !== options.length) return false;
          if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }

        fallback(variantId) {
          // Theme picker missing: set the variant on the form so add to cart is still correct.
          // Price and media will not update, so keep the theme Variant picker block in the template.
          console.warn('bm-variant-cards: theme variant picker not found, using fallback');
          document
            .querySelectorAll(`#product-form-${this.sectionId} input[name="id"]`)
            .forEach((idInput) => {
              idInput.value = variantId;
              idInput.dispatchEvent(new Event('change', { bubbles: true }));
            });
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }

        onIdChange(event) {
          const target = event.target;
          if (target.name !== 'id' || !target.form) return;
          if (target.form.id !== `product-form-${this.sectionId}`) return;
          const card = this.querySelector(`[data-bm-vc-input][value="${target.value}"]`);
          if (card && !card.checked) card.checked = true;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
